<a routerLink="/">Home</a> / Articles <br/><br/>
<div class="row page-header">
  <div class="col title">
    <h1>Articles</h1>
  </div>
</div>
<div class="grid-controls">
  <div class="search">
    <mat-form-field class="w-100 pr-5 no-subscript" appearance="outline">
      <mat-label>Search</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="searchText"
        (keyup)="onSearch()"
      />
      <button
        *ngIf="searchText"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="onSearchClear()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>
  <div class="buttons">
    <mat-button-toggle-group
      (change)="onChangeFilterType($event)"
      [(ngModel)]="searchField"
    >
      <mat-button-toggle
        [class]="{ 'toggle-active': searchField === 'title' }"
        value="title"
      >
        Title
      </mat-button-toggle>
      <mat-button-toggle
        [class]="{ 'toggle-active': searchField === 'sap_code' }"
        value="sap_code"
      >
        Sap code
      </mat-button-toggle>
      <mat-button-toggle
        [class]="{ 'toggle-active': searchField === 'product_code' }"
        value="product_code"
      >
        Product code
      </mat-button-toggle>
      <mat-button-toggle
        [class]="{ 'toggle-active': searchField === 'packaging' }"
        value="packaging"
      >
        Packaging
      </mat-button-toggle>
    </mat-button-toggle-group>

    <button
      mat-raised-button
      color="primary"
      routerLink="/articles/create"
    >
      New article
    </button>
  </div>
</div>
<div class="row">
  <div class="col">
    <div class="table-wrapper mat-elevation-z3">
      <div class="table-progress-overlay" *ngIf="dataSource.loading | async">
        <mat-progress-spinner mode="indeterminate" diameter="50">
        </mat-progress-spinner>
      </div>
      <table
        [dataSource]="dataSource"
        mat-table
        matSort
        [matSortActive]="sortActiveDefault"
        [matSortDirection]="sortDirectionDefault"
        matSortDisableClear
      >
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
          <td mat-cell *matCellDef="let element">
            <a [routerLink]="['/articles/', element.id]">{{ element.title }}</a>
          </td>
        </ng-container>
        <ng-container matColumnDef="sapCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>SAP code</th>
          <td mat-cell *matCellDef="let element">{{ element.sapCode }}</td>
        </ng-container>
        <ng-container matColumnDef="productCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Product Code
          </th>
          <td mat-cell *matCellDef="let element">{{ element.productCode }}</td>
        </ng-container>
        <ng-container matColumnDef="packaging">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Packaging</th>
          <td mat-cell *matCellDef="let element">{{ element.packaging }}</td>
        </ng-container>
        <ng-container matColumnDef="quantity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Quantity</th>
          <td mat-cell *matCellDef="let element">{{ element.quantity }}</td>
        </ng-container>
        <ng-container matColumnDef="content">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Content</th>
          <td mat-cell *matCellDef="let element">{{ element.content }}</td>
        </ng-container>
        <ng-container matColumnDef="updatedAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Last updated
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.updatedAt | date : "dd MMM yyyy hh:mm" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let element">
            <mat-icon
              (click)="
                onRemoveAction(element.id, element.title, element.sapCode)
              "
              class="text-danger--hover"
            >delete
            </mat-icon
            >
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data" [attr.colspan]="tableColumns.length">
            No data
          </td>
        </tr>
      </table>
      <mat-paginator
        [length]="totalItems"
        [pageSizeOptions]="pageSizeOptions"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>
  </div>
</div>
